import angular from 'angular';
import DiscountDetailsDialogComponent from './discount.details.dialog.component';
export default angular.module('inv.customer.orderHistory.orderDetails.discountDetailsDialog', []).component('discountDetailsDialog', DiscountDetailsDialogComponent).name;